module.exports = __webpack_public_path__ + "createaccountwp6bc4d85137ef27e6cbc70de8ad01649e.png";